import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { Box, Row } from 'seagull';
import { ChipConnector } from '../ChipConnector/ChipConnector';
import styles from './OrGroup.module.scss';
import { armReactKeys } from './OrGroup.utils';
export const OrGroup = (param)=>{
    let { testIds, arms, tone, connector, armGap, armWrap, groupWrap, renderArm, onToggle, trailing } = param;
    const reactKeys = armReactKeys(arms);
    const rendered = arms.map((arm, index)=>({
            index,
            units: renderArm(arm, index)
        })).filter((entry)=>entry.units.length > 0);
    if (rendered.length === 0) return null;
    return /*#__PURE__*/ _jsxs(Box, {
        testId: testIds.root,
        inline: true,
        wrap: groupWrap,
        className: styles.group,
        children: [
            rendered.map((entry, position)=>/*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        position > 0 && /*#__PURE__*/ _jsx(ChipConnector, _object_spread_props(_object_spread({}, connector), {
                            testId: testIds.connector(position),
                            tone: tone,
                            onToggle: onToggle
                        })),
                        /*#__PURE__*/ _jsx(Box, {
                            testId: testIds.arm(entry.index),
                            inline: true,
                            children: /*#__PURE__*/ _jsx(Row, {
                                alignItems: "center",
                                gap: armGap,
                                wrap: armWrap,
                                children: entry.units.map((unit)=>/*#__PURE__*/ _jsx(Fragment, {
                                        children: unit.node
                                    }, unit.key))
                            })
                        })
                    ]
                }, reactKeys[entry.index])),
            trailing
        ]
    });
};
